export default function(){

    if (!document.getElementsByClassName('SharePageNav').length) return

    document.getElementById('share-page--facebook').onclick = function (e) {
        e.preventDefault()
        FB.ui({
            method: 'share',
            display: 'popup',
            href: this.href,
        }, function (response) { });
    }

    let sharePage = document.getElementsByClassName('share-page'),
        sharePageLength = sharePage.length

    for (let i = 0; i < sharePageLength; i++) {
        sharePage[i].addEventListener('click', function (e) {
            e.preventDefault()
            let width = 1000,
                height = 500,
                left = (window.innerWidth - width) / 2,
                top = (window.innerHeight - height) / 2,
                url = this.href,
                opts = 'status=1' +
                    ',width=' + width +
                    ',height=' + height +
                    ',top=' + top +
                    ',left=' + left;

            window.open(url, 'Share Page', opts);
        })
    }
}